import { useState } from "react";
import { popularTabs, popularRanking, updateFeed } from "@/mocks/home";

const trendIcon: Record<string, { icon: string; color: string }> = {
  up: { icon: "ri-arrow-up-line", color: "text-primary-500" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-600" },
  same: { icon: "ri-subtract-line", color: "text-foreground-400" },
};

export default function PopularRanking() {
  const [activeTab, setActiveTab] = useState("day");
  const list = popularRanking[0][activeTab as "day" | "week" | "month"] ?? [];

  return (
    <section id="popular" className="w-full bg-background-50 px-4 py-10 md:px-6 md:py-14">
      <div className="mx-auto max-w-[1280px]">
        <div className="mb-6 flex flex-col gap-4 border-b border-background-200 pb-4 md:mb-8 md:flex-row md:items-end md:justify-between">
          <div className="min-w-0">
            <div className="mb-2 flex items-center gap-2">
              <span className="h-3.5 w-1 rounded-full bg-primary-500" />
              <span className="font-label text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
                Popularity
              </span>
            </div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-3xl">人气榜实时排行 TOP 8</h2>
            <p className="mt-2 text-sm text-foreground-600">按阅读增速与讨论热度计算，支持日、周、月三个维度切换查看。</p>
          </div>

          <div className="inline-flex shrink-0 items-center rounded-full border border-background-300 bg-background-100 p-1">
            {popularTabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors cursor-pointer ${
                  activeTab === tab.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_340px]">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            {list.map((item, i) => {
              const trend = trendIcon[item.trend] ?? trendIcon.same;
              return (
                <div
                  key={item.title}
                  className={`flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-50 md:px-5 ${
                    i !== list.length - 1 ? "border-b border-background-200" : ""
                  }`}
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                      i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">{item.title}</h3>
                      <span className="hidden shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800 sm:inline">
                        {item.genre}
                      </span>
                    </div>
                    <p className="mt-0.5 truncate text-xs text-foreground-500">{item.author}</p>
                  </div>
                  <div className="hidden w-32 shrink-0 items-center gap-2 md:flex">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-300">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${Number(item.hot)}%` }}
                      />
                    </div>
                    <span className="w-10 text-right text-xs font-semibold text-foreground-700">{item.hot}</span>
                  </div>
                  <i className={`${trend.icon} ${trend.color} hidden text-lg sm:block`} />
                </div>
              );
            })}
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-refresh-line text-primary-500" />
                最新更新动态
              </h3>
              <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-secondary-500" />
                实时
              </span>
            </div>
            <div className="flex flex-col gap-3">
              {updateFeed.map((feed) => (
                <div key={feed.id} className="flex items-start gap-3 border-b border-background-200 pb-3 last:border-0 last:pb-0">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className="ri-file-text-line text-base" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-foreground-900">{feed.title}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">
                      {feed.chapter} · <span className="text-secondary-700">{feed.genre}</span>
                    </p>
                  </div>
                  <span className="shrink-0 text-[11px] text-foreground-400">{feed.time}</span>
                </div>
              ))}
            </div>
            <button
              type="button"
              className="mt-4 w-full whitespace-nowrap rounded-md border border-background-300 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
            >
              查看全部更新
            </button>
          </aside>
        </div>
      </div>
    </section>
  );
}